import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { BnplService } from '../../shared/services/bnpl.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css'],
})
export class OnboardingComponent {
  urlCostsAndRates: string = `${environment.urlWebSite}inicio/costos`;
  authorizationCheck: boolean = false;

  navigationExtras: NavigationExtras = {};

  constructor(
    private readonly route: ActivatedRoute,
    private readonly bnplService: BnplService,
    private router: Router
  ) {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('commerce', '');
    this.route.queryParams.subscribe((params) => {
      if (params['id']) {
        const data = {
          actionStrategyPattern: 'SEARCH_CUSTOMER',
          id: params['id'],
        };
        this.bnplService.getPersonalInformation(data).subscribe({
          next: (resp: any) => {
            this.navigationExtras = { state: resp };
            if (resp != null) {
              localStorage.setItem('commerce', 'true');
              this.bnplService.personalInformation = resp;
              sessionStorage.setItem('urlRedirect', resp.urlRedirect);
            } else {
              sessionStorage.setItem('urlRedirect', '');
            }

            if (resp.showMessage == 2) {
              Swal.close();
              this.router.navigate(
                ['/await-alert', 'error'],
                this.navigationExtras
              );
            }
            if (resp.errorMessage) {
              this.router.navigate(['/await-alert', 'error-connection']);
            }
          },
          error: (e: any) => {
            Swal.close();
            this.router.navigate(['/await-alert', 'error-connection']);
            console.log('error', e);
          },
        });
      }
    });
  }

  handleNextStep() {
    this.router.navigate(['/basic-data']);
  }

  navigateToClient() {
    window.location.href = this.bnplService.personalInformation.urlRedirect;
  }
}
